import { Box, Button, Center, FormControl, FormErrorMessage, FormLabel, Heading, HStack, PinInput, PinInputField, Stack, useColorModeValue } from '@chakra-ui/react';
import { Form, Formik, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalLoading from '../../../components/Loader/ModalLoader.jsx';
import { urlNavigate } from '../../../helper/utils/navigation.js';
import { doSendOTP, doVerifyOTP } from '../../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../../layout/FormLayoutProvider.jsx';

export default function AuthVerifyOTP() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [pin, setPin] = useState('');

    const formik = useFormik({
        initialValues: {
            otp: '',
        },
        onSubmit: () => dispatch(doVerifyOTP({ otp: pin }, navigate)),
    });

    const handlePIN = (e) => setPin(e);

    const emailOTP = localStorage.getItem('emailOTP');
    const handleResendOTP = () => {
        dispatch(doSendOTP({ email: emailOTP }, navigate));
        resetTimer();
    };

    const [seconds, setSeconds] = useState(60);

    useEffect(() => {
        if (seconds > 0) {
            const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timer); // Cleanup the timer when the component unmounts
        }
    }, [seconds]);

    const formatTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const remainingSeconds = secs % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const resetTimer = () => setSeconds(60);

    const { loadingVerifyOTP } = useSelector((s) => s?.waiver);

    return (
        <FormLayoutProvider>
            <ModalLoading loading={loadingVerifyOTP} />
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12}>
                <Stack align={'center'}>
                    <Heading fontSize={'xl'}>Verify OTP from your email</Heading>
                </Stack>
                <Box rounded={'lg'} bg={useColorModeValue('white', 'gray.700')} boxShadow={'lg'} p={8}>
                    <Stack spacing={4}>
                        <Formik onSubmit={formik.handleSubmit} initialValues={formik.initialValues}>
                            <Form>
                                <FormControl id='otp' isInvalid={!!formik?.errors.otp && formik?.touched.otp}>
                                    <FormLabel>OTP</FormLabel>
                                    <Center>
                                        <HStack>
                                            <PinInput otp onChange={handlePIN} name='otp' id='otp' value={pin} size='lg' onComplete={handlePIN}>
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                            </PinInput>
                                        </HStack>
                                    </Center>
                                    <FormErrorMessage>{formik?.errors.otp}</FormErrorMessage>
                                </FormControl>

                                <Stack spacing={4} my={8}>
                                    <Button isDisabled={seconds > 0} onClick={handleResendOTP}>
                                        Resend OTP {seconds > 0 ? formatTime(seconds) : ''}
                                    </Button>

                                    <Button
                                        isDisabled={pin.length !== 6}
                                        type='submit'
                                        bg={'teal.400'}
                                        color={'white'}
                                        _hover={{
                                            bg: 'teal.500',
                                        }}>
                                        {t('next')}
                                    </Button>

                                    <Button onClick={() => navigate(urlNavigate('online-sales', 'home'))}>{t('fill_waiver')}</Button>
                                </Stack>
                            </Form>
                        </Formik>
                    </Stack>
                </Box>
            </Stack>
        </FormLayoutProvider>
    );
}
